import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";

import { PROJECT_DEPENDS_ON } from "@/schemas/commonFields/projectDependsOn";

const ProjectDependsOnSelect = forwardRef<
  HTMLButtonElement,
  ControllerRenderProps
>((props, ref) => (
  <EnumSelect
    options={PROJECT_DEPENDS_ON}
    translationKey="projectDependsOn"
    {...props}
    ref={ref}
  />
));

export default ProjectDependsOnSelect;
